import { forwardRef } from 'react';

type OwnProps = React.PropsWithoutRef<React.SVGProps<SVGSVGElement>>;

export default forwardRef<SVGSVGElement, OwnProps>((props, ref) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.264 20.51A9.98 9.98 0 0 0 22 12.716c0-5.523-4.477-10-10-10s-10 4.477-10 10a9.982 9.982 0 0 0 3.768 7.821 6.253 6.253 0 0 1 4.035-5.692 3.75 3.75 0 1 1 4.426 0 6.253 6.253 0 0 1 4.035 5.667z"
        fill="currentColor"
      />
    </svg>
  );
});
